module.exports = __webpack_public_path__ + "img/phone.5d7b5029.svg";